class Accordions {
    constructor(sel) {
        // view
        this.components = document.querySelectorAll(sel);

        if (this.components.length) {
            this.init();
        }
    }

    init() {
        this.components.forEach(comp => {
            this.initQuestions(comp);
        })
    }
    initQuestions(comp) {
        const questions = comp.querySelectorAll('li');
        questions.forEach(faq => {
            faq.addEventListener('click', () => {
                const isActive = faq.classList.contains('active');
                faq.classList.toggle('active');
                if (isActive) return;
            })
        })
    }
}

const accordions = new Accordions(".accordions");
